export const RECTANGLE = 'rectangle';
export const CIRCLE = 'circle';
export const TRIANGLE = 'triangle';

export const FIGURE_BOX = [RECTANGLE, CIRCLE, TRIANGLE];

const HANDLER = 'handler';
const CHOICE = 'choice';
const PEN = 'pen';
const THICKNESS = 'thickness';
const OPACITY = 'opacity';
const COLOR = 'color';
const ERASER = 'eraser';
const ALL_ERASER = 'all_eraser';
const FIGURE = 'figure';
const TEXT = 'text';
const ZOOM = 'zoom';

export const CANVAS_TOOL = {
    [HANDLER]: HANDLER,
    [CHOICE]: CHOICE,
    [PEN]: PEN,
    [THICKNESS]: THICKNESS,
    [OPACITY]: OPACITY,
    [COLOR]: COLOR,
    [ERASER]: ERASER,
    [ALL_ERASER]: ALL_ERASER,
    [FIGURE]: FIGURE,
    [TEXT]: TEXT,
    [ZOOM]: ZOOM
};

export const CANVAS_TOOL_LIST = [
    HANDLER,
    CHOICE,
    PEN,
    THICKNESS,
    OPACITY,
    COLOR,
    ERASER,
    ALL_ERASER,
    FIGURE,
    TEXT,
    ZOOM
];

export const CANVAS_TOOL_MOBILE_LIST = [
    HANDLER, PEN, ERASER, ALL_ERASER, TEXT, ZOOM
];

export const handler_list = [
    HANDLER, CHOICE
];
export const pen_list = [
    PEN, THICKNESS, OPACITY, FIGURE, COLOR
];